/**
 * The pre-recorded voice samples the site serves beside itself, written by
 * `npm run voice-samples` (10.7). Hearing a voice plays one of these files, so
 * it costs nothing and can be clicked as often as a staffer likes.
 *
 * A voice with no file gets no button. Falling back to synthesis would put the
 * spending back where removing it was the point.
 */

/** Voice ids that have a sample file, or an empty set when none are published. */
export async function loadVoiceSamples(): Promise<ReadonlySet<string>> {
  try {
    const response = await fetch("/voices/samples.json", { cache: "no-store" });
    if (!response.ok) return new Set();
    const body: unknown = await response.json();
    const ids = (body as { ids?: unknown }).ids;
    if (!Array.isArray(ids)) return new Set();
    return new Set(ids.filter((id): id is string => typeof id === "string"));
  } catch {
    // A site deployed before the samples were written simply has none.
    return new Set();
  }
}

export function voiceSampleUrl(id: string): string {
  return `/voices/${encodeURIComponent(id)}.mp3`;
}
